import {
  ThemeProvider,
  Typography,
  Button,
  CssBaseline,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { createTheme, Theme, adaptV4Theme } from '@mui/material/styles'
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route,Redirect } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import CustomerListPage from "./pages/CustomerListPage";
import MaterialSwapperPage from "./pages/MaterialSwapper";
import NotFoundPage from "./pages/NotFoundPage";
import CustomerPage from "./pages/CustomerPage";
import RoutePlanning from "./pages/RoutePlanning";
import AdjustClosingInventory from "./pages/RoutePlanning/AdjustClosingInventory";
import {
  MsalAuthenticationResult,
  MsalAuthenticationTemplate,
  MsalProvider
} from "@azure/msal-react";
import { SettingsPage } from "./pages/Settings";
import Axios from "axios";
import { useMsal } from "@azure/msal-react";
import { getAuth, checkForRole } from "./utils/GetAuth";
import { VendPrimeNotes } from "./pages/VendPrime/VendPrimeNotes";
import AdminPage from "./pages/AdminPage";
import ReportingConfigurationPage from "./pages/Reporting/Configuration";
import ReportingUtilizationPage from "./pages/Reporting/Utilization";
import ReportingPlanningPage from "./pages/Reporting/Planning";
import VMDEXPage from "./pages/Reporting/VMDEX";
import VMDEXSalesPage from "./pages/Reporting/VMDEXSales";
import VmMatTypeReport from "./pages/Reporting/VmMatTypeReport";
import FillRateReport from "./pages/Reporting/FillRate";
import MissedStopReport from "./pages/Reporting/MissedStop";
import VendPrimeRequestQueue from "./pages/VendPrime/VendPrimeRequestQueue";
import VendPrimeRequestMonitor from "./pages/VendPrime/VendPrimeRequestMonitor";
import { useLocalStorage } from "./utils/LocalStorageHook";
import CriticalFailure from "./pages/CriticalFailure";
import LoginSpinner from "./pages/LoginSpinner";
import OopsTimer from "./pages/OopsTimer";
import BottlerMapPage from "./pages/VendPrime/BottlerMapPage";
import RecommendationComponent from "./components/request/Recommend";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Color from "color";
import path from "path";

import { isIE } from "react-device-detect";
import NoSupportForIE from "./componentUtils/NoSupportForIE";
import { loginRequest, msalInstance } from "./utils/AuthenticationProvider";
import { InteractionStatus, InteractionType } from "@azure/msal-browser";
import AdminRouteManagement from "./components/admin/AdminRouteManagement";
import { Socket_Provider } from "./Socket_Provider";
import MaintenancePage from "./pages/MaintenancePage";
import RestrictedPage from "./pages/RestictedPage";
import { GetSysConfigMaintenance } from "./utils/GetAdmin";
import { TelemeterDashboard } from "./pages/Telemetry/TelemeterDashboard";
import RemotePriceManagement from "./pages/RemotePriceManagement/RemotePriceManagement";
import { Role_Provider } from './Role_Provider';

let baseURI = "//localhost:3002";
let baseFunctionURI = "//localhost:7071";
let useAuthentication = false;

if (process.env.NODE_ENV && process.env.NODE_ENV !== "development") {
  baseURI = "";
  useAuthentication = true;
  baseFunctionURI = ""
}

export const MUI_KEY = () => { return "03885d2b8e678125a4e5032fce97e4eaTz0xMTA0OTksRT0xNzc0NzQyMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=" }
export const BASE_URL = baseURI;
export const BASE_FUNCTION_URL = baseFunctionURI;
export const PUB_URL = process.env.PUBLIC_URL;
export const IS_PRODUCTION = process.env.NODE_ENV !== "development";
export const AXIOS_INSTANCE = Axios.create();

export function getPublicImagePath(imgPath: string) {
  return path.resolve(PUB_URL, imgPath);
}

const currentURL = window.location.href.toLowerCase();
export const IS_TEST_SERVER =
  process.env.NODE_ENV === "development" ||
  0 <= currentURL.indexOf("localhost") ||
  0 <= currentURL.indexOf("vending-dev") ||
  0 <= currentURL.indexOf("vending-mnt") ||
  0 <= currentURL.indexOf("vending-qa") ||
  0 <= currentURL.indexOf("vending-prf") ||
  0 <= currentURL.indexOf("ase-m-vdp-001") ||
  0 <= currentURL.indexOf("ase-d-vdp-001") ||
  0 <= currentURL.indexOf("ase-q-vdp-001") ||
  0 <= currentURL.indexOf("ase-l-vdp-001");


declare module "@mui/material/styles/createPalette" {
  interface Palette {
    QA: Palette['primary'];
    statusRed: Palette['primary'];
    statusYellow: Palette['primary'];
    statusGreen: Palette['primary'];
    statusBlue: Palette['primary'];
    statusOrange: Palette['primary'];
    statusPurple: PaletteOptions['primary'];
    highlightRow: Palette['primary'];
    dhighlightRow: Palette['primary'];
    border: Palette['primary'];
    mapMin: Palette['primary'];
    mapAvg: Palette['primary'];
    mapMax: Palette['primary'];
    mapClust: Palette['primary'];
    mapClustSel: Palette['primary'];
  }
  interface PaletteOptions {
    QA: PaletteOptions['primary'];
    statusRed: PaletteOptions['primary'];
    statusYellow: PaletteOptions['primary'];
    statusGreen: PaletteOptions['primary'];
    statusBlue: PaletteOptions['primary'];
    statusOrange: PaletteOptions['primary'];
    statusPurple: PaletteOptions['primary'];
    highlightRow: PaletteOptions['primary'];
    dhighlightRow: PaletteOptions['primary'];
    border: PaletteOptions['primary'];
    mapMin: PaletteOptions['primary'];
    mapAvg: PaletteOptions['primary'];
    mapMax: PaletteOptions['primary'];
    mapClust: PaletteOptions['primary'];
    mapClustSel: PaletteOptions['primary'];
  }
}

export default function App() {
 

  const [darkMode, setDarkMode] = useLocalStorage("SETTINGS.darkmode", false);
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const overrideCompact = useCompact ? {
    // Density changes.
    MuiTableCell: {
      root: {
        //This can be referred from Material UI API documentation.
        padding: "2px 4px",
        margin: "0 auto"
      }
    }
  } : {};


  useEffect(() => {
    MaintenancePageRedirect()
  }, [])


  const theme = createTheme(adaptV4Theme({
    props: {
      MuiTextField: {
        variant: 'standard'
      },
      MuiLink: {
        underline: 'hover'
      },
      MuiSelect: {
        variant: 'standard'
      },
      MuiFormControl: {
        variant: 'standard'
      },
      MuiButton: {
        sx: {
          margin: "8px",
          padding: "8px"
        }

      }
    },
    palette: {
      mode: darkMode ? "dark" : "light",
      primary: {
        main: "#e9232a"
      },
      QA: {
        main: process.env.NODE_ENV === "development" ? "#35ce8d" : "#9b489b"
      },
      secondary: {
        main: "#b71c1c"
      },
      border: {
        main: darkMode ? "#999999" : "#000000"
      },
      statusRed: {
        main: "#C11319"
      },
      statusYellow: {
        main: "#E9E325"
      },
      statusGreen: {
        main: "#4CAF50"
      },
      statusOrange: {
        main: "#ef5602",
      },
      statusBlue: {
        main: "#0d92be"
      },
      statusPurple: {
        main: "#9C27B0"
      },
      highlightRow: {
        main: darkMode ? "#ff6154" : "#FAD0D2"
      },
      dhighlightRow: {
        main: darkMode ? "#9D4346" : "#ff6154"
      },
      mapMin: {
        main: (darkMode
          ? Color.rgb(210, 200, 99)
          : Color.rgb(204, 192, 43)
        ).hex()
      },
      mapAvg: {
        main: (darkMode
          ? Color.rgb(134, 161, 91)
          : Color.rgb(84, 133, 64)
        ).hex()
      },
      mapMax: {
        main: (darkMode
          ? Color.rgb(69, 130, 122)
          : Color.rgb(40, 114, 110)
        ).hex()
      },
      mapClust: {
        main: darkMode ? "#b71c1c" : "#b71c1c"
      },
      mapClustSel: {
        main: darkMode ? "#ff6154" : "#e9232a"
      }
    },
    overrides: {
      ...overrideCompact
    }
  }));



  const conditionalAuth = (children: React.ReactNode) => {
    if (!useAuthentication) return <div>{children}</div>;
     return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
  };

  return conditionalAuth(<InternalWrapper theme={theme}>

    <Router>
      <Switch>
        <PrivateRoute path="/customers" component={CustomerListPage}/>
        <PrivateRoute path="/materialswap" component={MaterialSwapperPage}/>
        <PrivateRoute path="/bottlermap" component={BottlerMapPage}/>
        <PrivateRoute  path="/vendprime/queue" component={VendPrimeRequestQueue} />
        <PrivateRoute path="/vendprime/monitor" component={VendPrimeRequestMonitor} />
        <PrivateRoute path="/vendprime/notes" component={VendPrimeNotes}/>
        <PrivateRoute path="/reporting/configuration" component={ReportingConfigurationPage} />
        <PrivateRoute  path="/reporting/planning"  component={ReportingPlanningPage} />
        <PrivateRoute path="/reporting/vmdex" component={VMDEXPage}/>
        <PrivateRoute path="/reporting/utilization"component={ReportingUtilizationPage} />
        <PrivateRoute  path="/reporting/vmmattype" component={VmMatTypeReport}/>
        <PrivateRoute path="/reporting/fillrate" component={FillRateReport}/>
        <PrivateRoute path="/reporting/missedstop" component={MissedStopReport} />
        <PrivateRoute path="/routemanagement" component={AdminRouteManagement}/>
        <PrivateRoute path="/remotepricemanagement" component={RemotePriceManagement}/>
        <PrivateRoute path="/admin/:tab?/:subtab?" component={AdminPage}/>
        <PrivateRoute path="/vendsmart/planning" component={RoutePlanning}/>
        <PrivateRoute path="/vendsmart/adjustclosinginventory" component={AdjustClosingInventory}/>
        <PrivateRoute path="/reporting/vmdexsales/:identifier" component={VMDEXSalesPage}/>
        <PrivateRoute path="/customer/:identifier" component={CustomerPage} />
        <PrivateRoute path="/vendprime/reconfig/:customer/:identifier?" component={()=><RecommendationComponent fullpage={true} />} />
        <PrivateRoute path="/settings" component={SettingsPage}  />

        <PrivateRoute path="/telemeter_dashboard" component={()=>< TelemeterDashboard />}  />
        

        <PrivateRoute path="/maintenance" component={MaintenancePage}  />
        <PrivateRoute exact={true} path="/restricted" component={RestrictedPage} />
        {/* <Route path="/maintenance">
          <MaintenancePage />
        </Route> */}
        <PrivateRoute exact={true} path="/" component={LandingPage} />
        <Route component={NotFoundPage}></Route>
      </Switch>
    </Router>
  </InternalWrapper>);
}


export const ErrorComponent: React.FC<MsalAuthenticationResult> = ({
  error
}) => {
  return (
    <Typography variant="h6">
      An Error Occurred: {error ? error.errorCode : "unknown error"}
    </Typography>
  );
};

export const Loading = () => {
  return <LoginSpinner />;
};

function InternalWrapper(props: { theme: Theme; children: JSX.Element }) {
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const [dbSystemInd, setDbSystemInd] = useLocalStorage("SETTINGS.dbSystemInd", "?");
  const [authState, setAuthState] = useState("");
  const [userAccessLS, setUserAccessLS] = useLocalStorage(
    "SETTINGS.userAccess",
    {}
  );
  const [refreshRequired, setRefreshRequired] = React.useState(false);

  const { instance, accounts, inProgress } = useMsal();


  //const conaDev: any = acccess.filter((item: any) => item == "cona_internal_dev").length;
  //const isMaintenancePage = window.location.href.includes("/maintenance");
  // if (true) {
  //   window.location.href = "/maintenance";
  // }


  if (!authState && inProgress === InteractionStatus.None) {
    getAuth(instance, accounts)
      .then((t) => {
        AXIOS_INSTANCE.defaults.headers.common["Authorization"] = t.token;
        setUserAccessLS(t.userAccess);
        setDbSystemInd((t?.dbSystemInd) || '?');
        setAuthState(t.token || "");
      })
      .catch((err) => {
        let exclude = [
          'SETTINGS.CLP_displayableColumns',
          'SETTINGS.CLP_filters',
          'SETTINGS.userAccess',
          'SETTINGS.CLP_column_order',
          'SETTINGS.salesOrg',
          'SETTINGS.dbSystemInd',
          'context-keys',
          'SETTINGS.PBColSequence',
          'SETTINGS.VS_PLN_column_order',
          'SETTINGS.VS_PLN_sort',
          ' SETTINGS.VS_PLN_colsize',
          'SETTINGS.VS_PLN_filters',
          ' SETTINGS.VS_PLN_displayableColumns',
          'SETTINGS.darkmode'
        ]
        setRefreshRequired(true);
        //localStorage.clear();
        for (var key in localStorage) {
          if (!exclude.includes(key)) {
            localStorage.removeItem(key);
          }
        }
        //window.location.href = '/';
        window.location.reload();
        console.error(err);
      });
  }

  const content = authState ? props.children :<div />;

  // const loadingComponent = (<div>Loading...</div>)

  // const errorContent = (
  //   <CriticalFailure title="Error Logging In">
  //     <Typography paragraph>
  //       There was an error trying to log into the application.
  //     </Typography>
  //     <Typography paragraph>
  //       Please{" "}
  //       <Button
  //         variant="outlined"
  //         onClick={() => {
  //           window.location.reload();
  //         }}
  //       >
  //         refresh
  //       </Button>{" "}
  //       this page to attempt to log in again.
  //     </Typography>
  //   </CriticalFailure>
  // );

  const wrapAuthTemplate = (props: any) => {
    if (IS_PRODUCTION) {
      return (<MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
        errorComponent={ErrorComponent}
        loadingComponent={Loading}
      >
        {props}
      </MsalAuthenticationTemplate>)
    }

    return <div>{props}</div>
  }
  
  return (
   
    <ThemeProvider theme={props.theme}>
      <CssBaseline />
      <NoSupportForIE isIE={isIE} />
      <DndProvider backend={HTML5Backend}>
      <Role_Provider>
        <Socket_Provider> 
          <div>{content}</div>
          {refreshRequired ? (<h3 style={{ marginTop: '87px', textAlign: 'center' }}>VendPrime VendSmart Application had been updated recently. Kindly refresh the screen to continue with. </h3>) : <></>}
        </Socket_Provider>
      </Role_Provider>
      </DndProvider>
    </ThemeProvider>
    
  );
}

export  function MaintenancePageRedirect  (){
  try {
    let userAccess: any = window.localStorage.getItem('SETTINGS.userAccess')
    let userAcess = JSON.parse(userAccess)
    let is_cona_internal = false;
    if(userAcess){
    if (Object.keys(userAcess)[0]) {
      if (Object.keys(userAcess[Object.keys(userAcess)[0]])[0]) {
        let salesOrg = Object.keys(userAcess[Object.keys(userAcess)[0]])[0]
        is_cona_internal = userAcess[Object.keys(userAcess)[0]][Object.keys(userAcess[Object.keys(userAcess)[0]])[0]]?.includes("cona_internal_dev")
        GetSysConfigMaintenance(salesOrg, { vp: true, vs: true })
          .then((response: any) => {
            if (response) {
              if (response.param_value === 'true' && !is_cona_internal) {
                window.localStorage.setItem('SETTINGS.is_maintenance','true')   
              }else{
                window.localStorage.setItem('SETTINGS.is_maintenance','false')
              }
            }
          })
      }
    }
  }
  } catch (error) {
    throw new Error("MaintenancePageRedirect Error");
  }
}
interface IProps {
  exact?: boolean;
  path: string;
  component: React.ComponentType<any>;
}

const checkForRestrictedPages = (clientId: string, salesOrg: string)=>{
    const restrictedPathPattern: any = ["/admin", "/vendprime", "/adjustclosinginventory", "/materialswap","/routemanagement",]
    const path: string =  window.location.pathname;
    
    const isDisplayOnlyRole: boolean = (!checkForRole(clientId, salesOrg, "vs_submit_schedule") && 
        checkForRole(clientId, salesOrg, "vs_review") && 
        checkForRole(clientId, salesOrg, "vs_access"));

    let isPathIncluded: boolean = false;
    for(let i=0; i<=restrictedPathPattern.length; i++){
      isPathIncluded = path.includes(restrictedPathPattern[i]);
      if(isPathIncluded)
          break;
    }
    const isRestrictedPage: boolean = isDisplayOnlyRole && isPathIncluded;
    return isRestrictedPage;
}

export  function PrivateRoute({exact = false,path,component}: IProps) {
  const  isLoggedIn:any= window.localStorage.getItem('SETTINGS.is_maintenance') || 'false';
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        if (isLoggedIn=='true' && window.location.pathname !='/maintenance') {
          return   <Redirect
          to={{
            pathname: "/maintenance",
            state: { from: props.location }
          }}
        />
        } else if (isLoggedIn=='false' && window.location.pathname ==='/maintenance') {
            return   <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        }
        if(checkForRestrictedPages(clientId, salesOrg)){
          return   <Redirect
          to={{
            pathname: "/restricted",
            state: { from: props.location }
          }}
        />
        }
        return (<Route {...props} component={component} /> );
      }}
    />
  );
}
